function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { DetailContainer } from "../../components/container-activity";
import { BaseDataViewComponent } from "../../components/base";
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import { MDCTextInput, MDCFileUpload } from '../../../jsx/components/mdc-components';
import { AlertMessage } from '../../ui/alert';
import ProgressSuccess from '../../ui/progress/success';
import endpoints from "../../endpoints";
import account from "../../data/account";
import Auth from "../../functions/authenticate";
import ServiceFactory from "../../service";
class MainComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "initServices", () => {
      var Service = ServiceFactory.getType('/research-assistant', 'research');
      this.Service = new Service();
    });
    _defineProperty(this, "onChange", event => {
      var target = event.target;
      var value = target.value;
      this.setState({
        instruction: value
      });
    });
    _defineProperty(this, "onGoBack", () => {
      this.props.history.goBack();
    });
    _defineProperty(this, "onFocus", event => {
      this.setState({
        showMessage: false,
        messageType: '',
        message: null
      });
    });
    _defineProperty(this, "onSuggesion1Click", event => {
      let instruction = 'Who are the top fashion designers right now?';
      this.post(instruction);
    });
    _defineProperty(this, "onSuggesion2Click", event => {
      let instruction = "What's trending right now in the luxury goods market?";
      this.post(instruction);
    });
    _defineProperty(this, "onSuggesion3Click", event => {
      let instruction = 'What are the high end zip codes in Texas?';
      this.post(instruction);
    });
    _defineProperty(this, "onViewClick", () => {
      this.props.history.goBack();
    });
    _defineProperty(this, "onCreate", event => {
      let state = this.state;
      let message = null;
      let messageType = null;
      let showMessage = false;
      if (!state.instruction) {
        showMessage = true;
        messageType = 'error';
        message = 'Instruction Required...';
        this.setState({
          showMessage,
          messageType,
          message
        });
      } else {
        this.post();
      }
    });
    _defineProperty(this, "post", instruction => {
      let state = this.state;
      if (!instruction) instruction = state.instruction;
      let model = {
        instruction: instruction,
        userId: state.userId
      };
      let message = null;
      let messageType = null;
      let showMessage = false;
      let showSuggestions = false;
      let showSuccess = true;
      this.Service.post(model, (err, data) => {
        if (!err) {
          this.setState({
            showMessage,
            messageType,
            message,
            showSuccess,
            showSuggestions
          });
        } else {
          showSuccess = false;
          messageType = 'error';
          showMessage = true;
          showSuggestions = true;
          message = 'Error submitting company analysis...';
          this.setState({
            showMessage,
            messageType,
            message,
            showSuccess,
            showSuggestions
          });
        }
      });
    });
    this.state = this.initState();
  }
  initState() {
    var auth = Auth.get();
    var email = auth.email;
    return {
      instruction: '',
      showSuccess: false,
      showMessage: false,
      showSuggestions: true,
      messageType: '',
      message: null,
      userId: email
    };
  }
  componentDidMount() {
    this.initServices();
    publishSearch('Research');
    publishEvent('reset-search', {});
  }
  render() {
    let state = this.state;
    return /*#__PURE__*/React.createElement(DetailContainer, {
      title: "New Research Assistant",
      onGoBack: this.onGoBack
    }, state.showSuccess ? /*#__PURE__*/React.createElement(ProgressSuccess, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "medium size-14"
    }, "Your research assistant has been successfully submitted.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("div", {
      className: "size-14"
    }, /*#__PURE__*/React.createElement("a", {
      onClick: this.onViewClick
    }, "VIEW ASSISTANTS GRID")))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "flex-box"
    }, /*#__PURE__*/React.createElement("div", {
      className: "form-width"
    }, /*#__PURE__*/React.createElement(MDCTextInput, {
      placeholder: "What should I research for you?",
      value: state.instruction,
      onChange: this.onChange,
      onFocus: this.onFocus
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
      className: "ui-button primary margin-left",
      onClick: this.onCreate
    }, "Research"))), /*#__PURE__*/React.createElement("br", null), state.showSuggestions && /*#__PURE__*/React.createElement("div", {
      className: "assistant-suggestions-box"
    }, /*#__PURE__*/React.createElement("div", {
      className: "r1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "suggestion",
      onClick: this.onSuggesion1Click
    }, "Who are the top fashion designers right now?"), /*#__PURE__*/React.createElement("div", {
      className: "suggestion",
      onClick: this.onSuggesion2Click
    }, "What's trending right now in the luxury goods market?")), /*#__PURE__*/React.createElement("div", {
      className: "r2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "suggestion",
      onClick: this.onSuggesion3Click
    }, "What are the high end zip codes in Texas?"))), state.showMessage && /*#__PURE__*/React.createElement(AlertMessage, {
      message: state.message,
      cls: state.messageType
    }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null));
  }
}
export class ResearchAssistantCreateViewComponent extends BaseDataViewComponent {
  constructor(props) {
    super(props);
  }
  fetchData() {
    setTimeout(() => {
      this.allowRender = true;
      this.data = {};
      this.forceUpdate();
    }, 100);
  }
  render() {
    if (!this.allowRender) {
      return null;
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        params: this.props.params
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  ResearchAssistantCreateViewComponent
};